<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description" [innerHTML]="getLangValue(stepData?.description)"></div>
  <div *ngFor="let option of stepData?.options" class="survey-option" [class.selected]="selectedOptionId === option._id">
    <button type="button" (click)="onSelectOption(option)" [class.selected]="selectedOptionId === option._id">
      {{ getLangValue(option.text) }}
      <span *ngIf="option.inputType === 'text'" class="specify-label"> ({{ getLangValue(option.description) }})</span>
    </button>
    <div *ngIf="selectedOptionId === option._id && option.inputType === 'text'">
      <input type="text" [(ngModel)]="textValue" [placeholder]="getLangValue(option.description)" />
    </div>
  </div>
</div>
